import { createMuiTheme, makeStyles } from "@material-ui/core/styles";

import { MP } from "./mpConstants";

export const useMonitoramentoStyles = makeStyles(() => ({
  pageRoot: {
    fontFamily: MP.font,
    backgroundColor: MP.pageBg,
    minHeight: "calc(100vh - 64px)",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    padding: "28px 24px 56px",
    overflowX: "hidden",
    "@media (max-width: 600px)": {
      padding: "20px 16px 48px",
    },
  },
  inner: {
    maxWidth: 1180,
    width: "100%",
    minWidth: 0,
    margin: "0 auto",
    boxSizing: "border-box",
  },
  topBar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    marginBottom: 28,
    minWidth: 0,
    width: "100%",
  },
  titleBlock: { flex: "1 1 280px", minWidth: 0 },
  titleMain: {
    color: MP.primary,
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: 1.25,
    margin: 0,
    letterSpacing: "-0.02em",
  },
  subtitle: {
    color: MP.textMuted,
    fontSize: "0.9375rem",
    lineHeight: 1.5,
    marginTop: 8,
    maxWidth: 560,
  },
  minhasColetasBtn: {
    borderRadius: MP.radiusMd,
    border: `2px solid ${MP.primary}`,
    color: MP.primary,
    fontWeight: 600,
    textTransform: "none",
    padding: "8px 18px",
    fontSize: "0.875rem",
    "&:hover": {
      border: `2px solid ${MP.primaryHover}`,
      backgroundColor: "rgba(0, 86, 179, 0.04)",
    },
  },
  formSection: {
    backgroundColor: MP.cardBg,
    border: `1px solid ${MP.border}`,
    borderRadius: MP.radiusLg,
    boxShadow: MP.shadow,
    padding: "22px 26px 26px",
    marginBottom: 20,
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box",
    overflow: "visible",
    "@media (max-width: 600px)": {
      padding: "18px 16px 20px",
    },
  },
  sectionTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 18,
  },
  sectionTitleRowLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  sectionBadge: {
    flexShrink: 0,
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: MP.primary,
    color: "#fff",
    fontWeight: 700,
    fontSize: "0.875rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
  },
  sectionTitleText: {
    color: MP.primary,
    fontWeight: 700,
    fontSize: "0.8125rem",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    lineHeight: 1.3,
  },
  tipoGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    alignItems: "stretch",
  },
  tipoCard: {
    flex: "1 1 240px",
    minHeight: 100,
    border: `2px solid ${MP.border}`,
    borderRadius: MP.radiusMd,
    padding: "16px 18px",
    cursor: "pointer",
    backgroundColor: MP.cardBg,
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      borderColor: "#b8c5d6",
    },
  },
  tipoCardSelected: {
    borderColor: MP.primary,
    boxShadow: `0 0 0 1px ${MP.primary}`,
  },
  tipoCardDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  tipoCardTitle: {
    fontWeight: 600,
    fontSize: "0.9375rem",
    color: MP.text,
  },
  tipoCardSub: {
    fontSize: "0.8125rem",
    color: MP.textMuted,
    marginTop: 4,
    lineHeight: 1.4,
  },
  tableScroll: {
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    marginTop: 4,
    borderRadius: MP.radiusMd,
    border: `1px solid ${MP.border}`,
    overscrollBehaviorX: "contain",
  },
  table: {
    width: "100%",
    minWidth: 720,
    borderCollapse: "collapse",
    "@media (max-width: 959px)": {
      width: "max-content",
      maxWidth: "none",
    },
    "& thead th": {
      backgroundColor: MP.tableHead,
      color: MP.text,
      fontWeight: 600,
      fontSize: "0.75rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      padding: "12px 14px",
      borderBottom: `1px solid ${MP.border}`,
      textAlign: "left",
    },
    "& tbody td": {
      padding: "12px 14px",
      borderBottom: `1px solid ${MP.border}`,
      fontSize: "0.875rem",
      verticalAlign: "middle",
      color: MP.text,
    },
    "& tbody tr:last-child td": {
      borderBottom: "none",
    },
  },
  concorrenteNome: {
    fontWeight: 600,
    color: MP.text,
  },
  concorrenteRowDestaque: {
    backgroundColor: "rgba(0, 86, 179, 0.06)",
    "& td": {
      backgroundColor: "rgba(0, 86, 179, 0.06)",
    },
  },
  concorrenteRefHint: {
    display: "block",
    fontSize: "0.72rem",
    color: MP.textMuted,
    fontWeight: 400,
    marginTop: 4,
    lineHeight: 1.35,
    maxWidth: 220,
  },
  dashCell: {
    color: MP.textMuted,
    fontSize: "1rem",
  },
  infoCallout: {
    display: "flex",
    alignItems: "flex-start",
    gap: 14,
    marginTop: 18,
    padding: "14px 18px",
    backgroundColor: MP.primarySoft,
    borderRadius: MP.radiusMd,
    border: `1px solid rgba(0, 86, 179, 0.12)`,
  },
  infoCalloutTitle: {
    color: MP.primary,
    fontWeight: 700,
    fontSize: "0.875rem",
    marginBottom: 4,
  },
  infoCalloutBody: {
    color: MP.textMuted,
    fontSize: "0.8125rem",
    lineHeight: 1.5,
  },
  listActionsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 20,
    alignItems: "flex-start",
    marginTop: 4,
    marginBottom: 20,
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    "@media (max-width: 959px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  listMain: {
    flex: "1 1 360px",
    minWidth: 0,
    "@media (max-width: 959px)": {
      width: "100%",
      maxWidth: "100%",
    },
  },
  listSidebar: {
    flex: "0 0 280px",
    width: "100%",
    maxWidth: 320,
    "@media (max-width: 959px)": {
      flex: "1 1 100%",
      maxWidth: "100%",
    },
  },
  sidebarCard: {
    backgroundColor: MP.cardBg,
    border: `1px solid ${MP.border}`,
    borderRadius: MP.radiusLg,
    boxShadow: MP.shadow,
    padding: "20px 22px 22px",
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 18,
    color: MP.primary,
    fontWeight: 600,
    fontSize: "0.9375rem",
  },
  btnPrimaryFull: {
    width: "100%",
    borderRadius: MP.radiusMd,
    backgroundColor: MP.primary,
    color: "#fff",
    fontWeight: 600,
    textTransform: "none",
    padding: "12px 16px",
    fontSize: "0.9375rem",
    marginBottom: 12,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: MP.primaryHover,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: "#b0bec5",
      color: "#fff",
    },
  },
  btnOutlineFull: {
    width: "100%",
    borderRadius: MP.radiusMd,
    border: `2px solid ${MP.primary}`,
    color: MP.primary,
    fontWeight: 600,
    textTransform: "none",
    padding: "10px 16px",
    fontSize: "0.9375rem",
    "&:hover": {
      border: `2px solid ${MP.primaryHover}`,
      backgroundColor: "rgba(0, 86, 179, 0.04)",
    },
    "&.Mui-disabled": {
      borderColor: MP.border,
      color: MP.textMuted,
    },
  },
  fotoBtn: {
    borderRadius: MP.radiusMd,
    border: `1px solid ${MP.border}`,
    color: MP.primary,
    textTransform: "none",
    fontSize: "0.75rem",
    fontWeight: 600,
  },
  thumb: {
    maxWidth: 76,
    maxHeight: 76,
    objectFit: "cover",
    borderRadius: 6,
    border: `1px solid ${MP.border}`,
  },
  iconAction: {
    padding: 6,
    color: "#546e7a",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
  },
  iconDelete: {
    padding: 6,
    color: MP.danger,
    "&:hover": { backgroundColor: "rgba(198, 40, 40, 0.06)" },
  },
  footerNote: {
    marginTop: 10,
    fontSize: "0.75rem",
    color: MP.textMuted,
  },
  radioLabel: {
    marginRight: 12,
    "& .MuiFormControlLabel-label": {
      fontSize: "0.8125rem",
      color: MP.text,
    },
  },
  produtoRefGrid: {
    marginTop: 4,
    width: "100%",
    minWidth: 0,
  },
  produtoColSku: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 16,
  },
  produtoColMeta: {
    paddingTop: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  produtoColPreco: {
    paddingTop: 2,
  },
  produtoFoto: {
    width: "100%",
    maxWidth: 220,
    height: 220,
    objectFit: "cover",
    borderRadius: MP.radiusMd,
    border: `1px solid ${MP.border}`,
    backgroundColor: MP.tableHead,
    display: "block",
  },
  produtoMetaBlock: {
    fontSize: "0.9375rem",
    lineHeight: 1.55,
    color: MP.text,
  },
  produtoMetaLine: {
    marginBottom: 12,
    "&:last-child": {
      marginBottom: 0,
    },
  },
  produtoMetaLabel: {
    display: "block",
    fontSize: "0.75rem",
    color: MP.textMuted,
    fontWeight: 600,
    marginBottom: 2,
    letterSpacing: "0.02em",
  },
  produtoMetaValue: {
    fontSize: "0.9375rem",
    color: MP.text,
    fontWeight: 400,
  },
  loadingWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 420,
    gap: 20,
    padding: "40px 24px",
  },
  loadingText: {
    color: MP.textMuted,
    fontSize: "0.9375rem",
    textAlign: "center",
  },
  unavailableCard: {
    backgroundColor: MP.cardBg,
    border: `1px solid ${MP.border}`,
    borderRadius: MP.radiusLg,
    boxShadow: MP.shadow,
    padding: "32px 28px",
    maxWidth: 560,
    margin: "48px auto 0",
  },
  unavailableTitle: {
    color: MP.primary,
    fontWeight: 700,
    fontSize: "1.125rem",
    marginBottom: 12,
  },
  unavailableBody: {
    color: MP.textMuted,
    fontSize: "0.9375rem",
    lineHeight: 1.55,
  },
  minhasColetasDialogPaper: {
    borderRadius: MP.radiusLg,
    maxWidth: 960,
    width: "100%",
  },
  cadastroConcorrenteDialogPaper: {
    borderRadius: MP.radiusLg,
    maxWidth: 560,
    width: "100%",
  },
  cadastroRefBox: {
    backgroundColor: "#f4f7fb",
    border: `1px solid ${MP.border}`,
    borderRadius: MP.radiusMd,
    padding: "12px 14px",
  },
  cadastroFieldsPanel: {
    border: `1px solid ${MP.border}`,
    borderRadius: MP.radiusMd,
    padding: "16px 16px 4px",
    backgroundColor: MP.cardBg,
  },
  cadastroSectionCaption: {
    color: MP.textMuted,
    fontSize: "0.8125rem",
    fontWeight: 600,
    letterSpacing: "0.02em",
    marginBottom: 10,
    textTransform: "uppercase",
  },
  cadastroFieldLabel: {
    display: "block",
    color: MP.text,
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: 1.5,
    marginBottom: 6,
    "&.Mui-disabled": {
      color: MP.text,
    },
    "&.Mui-focused": {
      color: MP.text,
    },
  },
  cadastroSelectControl: {
    marginTop: 0,
    marginBottom: 0,
    backgroundColor: MP.cardBg,
    "& .MuiOutlinedInput-root": {
      borderRadius: MP.radiusMd,
    },
    "& .MuiOutlinedInput-input": {
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      padding: "7px 32px 8px 10px !important",
      fontSize: "0.875rem",
      lineHeight: 1.43,
    },
    "& .MuiSelect-icon": {
      top: "50%",
      transform: "translateY(-50%)",
      color: MP.textMuted,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
  },
  cadastroSelectPlaceholder: {
    color: MP.textMuted,
    lineHeight: 1.4,
  },
  cadastroSelectEmptyHint: {
    marginTop: 4,
    marginLeft: 0,
    fontSize: "0.8125rem",
  },
  minhasColetasDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: 8,
  },
  minhasColetasTableWrap: {
    maxHeight: 480,
    overflow: "auto",
    border: `1px solid ${MP.border}`,
    borderRadius: MP.radiusMd,
  },
  minhasColetasDetailCell: {
    backgroundColor: MP.primarySoft,
    borderTop: "none",
    paddingTop: 12,
    paddingBottom: 16,
  },
  minhasColetasDetailList: {
    margin: 0,
    paddingLeft: 18,
    fontSize: "0.8125rem",
    color: MP.text,
    lineHeight: 1.5,
  },
  minhasColetasPagination: {
    borderTop: `1px solid ${MP.border}`,
    marginTop: 8,
  },
}));

export const mpTheme = createMuiTheme({
  palette: {
    primary: { main: MP.primary },
    text: { primary: MP.text, secondary: MP.textMuted },
  },
  typography: {
    fontFamily: MP.font,
  },
});
